import { render, staticRenderFns } from "./ViajesInfoLiquidacion.vue?vue&type=template&id=184129a1"
import script from "./ViajesInfoLiquidacion.vue?vue&type=script&lang=js"
export * from "./ViajesInfoLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports